import $ from 'jquery';
import ModalFactory from 'chairisher/factory/modal';
import VariantColorView from 'chairisher/view/product/variant/color';

/**
 * @param {Object} options
 * @param {string} options.triggerElSelector
 *
 * @class VariantEdit
 * @constructor VariantEdit
 */
class VariantEdit {
    constructor(triggerElSelector = '.js-create-variant') {
        this.triggerElSelector = triggerElSelector;
    }

    /**
     * Set up and shows an error modal
     *
     * @param {Object} response Object returned by the server
     */
    showEditErrorModal(response) {
        const closeClass = 'js-close';
        const $modal = ModalFactory.createModal('variant-edit-error-modal');
        const $modalAction = $('<button></button>', {
            class: `btn btn-default ${closeClass}`,
            text: 'ok',
            type: 'button',
        });
        const $modalDescription = $('<p></p>', {
            text: response.error.description,
        });
        const $modalTitle = $('<h3></h3>', {
            class: 'title',
            text: response.error.title,
        });

        $modal.find('.js-modal-header').append($modalTitle);
        $modal.find('.js-modal-body').append($modalDescription, $modalAction);

        $modal.find(`.${closeClass}`).on('click', (e) => {
            e.preventDefault();
            $modal.modal('hide');
        });
        $modal.on('hidden.bs.modal', () => {
            $modal.remove();
        });

        $modal.modal('show');
    }

    /**
     * Sets up and shows the create/edit modal
     *
     * @param {Object} response Object returned by the server
     */
    showEditModal(response) {
        const $modal = $('.js-variant-edit-modal');
        const $modalForm = $modal.find('.js-variant-create-form');
        const $canonicalProductCard = $modal.find('.js-canonical-product-card');
        const $submitButton = $modal.find('.js-submit-btn');
        const $errorsEl = $modal.find('.js-errors');
        const markSelectedAttribute = (selectedAttr) => {
            const $attrValues = $canonicalProductCard.find('.js-variant-attribute-value');
            $attrValues.each((i) => {
                const $value = $attrValues.eq(i);
                $value.toggleClass('hidden', $value.data('attribute-code') !== selectedAttr);
            });
        };
        const removeErrors = () => {
            $errorsEl.text('');
            $errorsEl.closest('.js-form-group').removeClass('has-error');
        };

        $modalForm.attr('action', response.form_url);
        $modal.find('.js-title').text(response.title);
        $modal.find('.js-modal-description').text(response.description);
        $canonicalProductCard.html(response.canonical_product_card);
        $submitButton.text(response.button_text);
        removeErrors();

        if (response.parent_id) {
            const $parentIdInput = $('<input/>', {
                type: 'hidden',
                name: 'parent_id',
                value: response.parent_id,
            });
            $modalForm.append($parentIdInput);
        }

        const $variantAttrChoices = $modal.find('.js-variant-attribute-choices');
        $variantAttrChoices.empty();
        const $variantAttrChoiceSkeleton = $('.js-variant-attribute-choice-skeleton');
        $.each(response.variable_attribute_groups, (i, attrGroup) => {
            const $variantAttrChoice = $($variantAttrChoiceSkeleton.html());
            const $variantAttrChoiceInput = $variantAttrChoice.find('input');
            $variantAttrChoiceInput.val(attrGroup.code);
            if (attrGroup.is_selected) {
                $variantAttrChoiceInput.prop('checked', true);
                markSelectedAttribute(attrGroup.code);
            }
            $variantAttrChoice.find('.js-choice-text').text(attrGroup.display_name);
            $variantAttrChoice.find('.js-help-text').text(attrGroup.help_text);
            $variantAttrChoice.appendTo($variantAttrChoices);
        });

        const $variantAttrChoiceInputs = $('.js-variant-attribute-choices [name="attribute_group"]');
        $variantAttrChoiceInputs.on('click', (e) => {
            markSelectedAttribute($(e.target).val());
            removeErrors();
        });

        VariantColorView.render();

        $submitButton.on('click', (e) => {
            if ($variantAttrChoiceInputs.filter(':checked').length === 0) {
                e.preventDefault();
                $errorsEl.text('Please choose your variable attribute.');
                $errorsEl.closest('.js-form-group').addClass('has-error');
            } else {
                $(window).off('beforeunload');
            }
        });

        $modal.find('.js-cancel').one('click', (e) => {
            e.preventDefault();
            $modal.modal('hide');
        });

        $modal.on('hidden.bs.modal', () => {
            $submitButton.off('click');
        });

        $modal.modal('show');
    }

    /**
     * Binds trigger that opens the view modal
     */
    bindTrigger() {
        $(this.triggerElSelector).on('click', (e) => {
            e.preventDefault();

            $.ajax({
                url: $(e.target).attr('href'),
            }).done((data) => {
                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                } else if (data.error) {
                    this.showEditErrorModal(data);
                } else {
                    this.showEditModal(data);
                }
            });
        });
    }
}
export default VariantEdit;
